import { t } from "@lingui/core/macro";
import dayjs from "dayjs";
import { useState } from "react";
import { deleteCustomerWithId, getCustomerData } from "../apiSchedule";
import { toast } from "sonner";

export const useCustomers = () => {
  const [customerData, setCustomerData] = useState(null);

  const deleteCustomer = async (customerId) => {
    const token = localStorage.getItem("usr_token");
    try {
      await deleteCustomerWithId(customerId, token);
    } catch (error) {
      console.error(error);
    }
  };

  const refreshCustomerData = async (customerId) => {
    const token = localStorage.getItem("usr_token");

    try {
      const customer = await getCustomerData(
        customerId ?? customerData?.customerId,
        token,
      );

      if (customer.status === 200) {
        setCustomerData({
          ...customer.data,
          birthday: customer.data.birthday
            ? dayjs(customer.data.birthday).toDate()
            : null,
        });
      } else {
        console.error(customer);
      }
    } catch (e) {
      if (e.response) {
        const errorMessage =
          e.response.data?.error ||
          e.response.data?.message ||
          t`Napaka med pridobivanjem podatkov o stranki`;
        toast.error(errorMessage);
      } else if (e.request) {
        toast.error(t`Ni bilo mogoče vzpostaviti povezave s strežnikom`);
      } else {
        toast.error(t`Napaka med pridobivanjem podatkov o stranki`);
      }
    }
  };

  return {
    deleteCustomer,
    setCustomerData,
    customerData,
    refreshCustomerData,
  };
};
